import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faChevronLeft,
    faHouse, faHeartCircleCheck, faHeartCirclePlus, faBarcode, faMagnifyingGlass, faPlus, faMinus, faBars, faAngleRight, faArrowLeft, faUser,
    faCartShopping, faPaperPlane, faClose, faCashRegister, faBoxes, faLock, faBasketShopping, faBoxesStacked,
    faReceipt, faGear, faXmark, faChevronRight, faArrowRightFromBracket, faCreditCard, faMoneyBill, faAnglesUp,faAnglesDown,
    faChevronUp,faChevronDown,faPercentage,faCheckCircle,faMobileAlt,faLaptop,
    faBowlFood,faArrowsRotate, faLayerGroup, faPenToSquare, faUsers, faUserPlus, faHandHoldingDollar, faCoins, faArrowRotateLeft,
    faGears, faMoneyBills, faArrowTrendDown, faRotateLeft, faPrint, faTrash,faTable,faSave,faChartLine,faUpload,faFolderTree,faCancel,
    faCommentsDollar,faQuestionCircle,faChartSimple,faHandHoldingDroplet,faEnvelope,faExchange,faSliders,
    faArrowDown,faArrowUp,faShuffle,faArrowRight,faChartBar,faEye,faMoneyCheck,faExclamationCircle, faBell, faUserGear,
    faBusinessTime,faFingerprint,faImage,faCheck,faFileInvoice,faWallet,faClipboard,
    faTriangleExclamation,faCalendarCheck,faClipboardList,faDownload,faComments,faFileArrowUp,faLink, faFileContract,
    // Added new icons
    faUserCircle, faTruck, faFileLines, faFileInvoiceDollar, faTruckFast, faHandshake, faKey, faCogs,
    faMoneyBillTrendUp, faVault, faTags, faSitemap, faBuilding, faBook, faPercent, faFileExport,
    faUsersGear, faHeadset, faTicket, faTicketSimple, faStore, faBuildingUser, faRightFromBracket, faPuzzlePiece,
    // Added icons for StoreManagements.vue
    faSignInAlt, faPlusCircle, faTag, faInfoCircle,
    // Added missing icons used in components
    faExchangeAlt, faMoneyBillWave, faUniversity,
    // Added missing icons for StockView.vue
    faTruckLoading, faFileSignature,
    // Added missing icon for SecurityManagementView.vue
    faEllipsisH,
    // Added missing icon for Invoices page
    faRedo,
    // Added missing icons for FranchiseInvoices.vue
    faClock, faFileUpload,
    // Added missing desktop icon
    faDesktop

} from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
    faChevronLeft,
    faHouse, faHeartCircleCheck, faHeartCirclePlus, faBarcode, faMagnifyingGlass, faPlus, faMinus, faBars, faAngleRight, faArrowLeft, faUser,
    faCartShopping, faPaperPlane, faClose, faCashRegister, faBoxes, faLock, faBasketShopping, faBoxesStacked,
    faReceipt, faGear, faXmark, faChevronRight, faArrowRightFromBracket, faCreditCard, faMoneyBill, faAnglesUp, faAnglesDown,
    faChevronUp, faChevronDown, faPercentage, faCheckCircle, faMobileAlt, faLaptop,
    faBowlFood, faArrowsRotate, faLayerGroup, faPenToSquare, faUsers, faUserPlus, faHandHoldingDollar, faCoins, faArrowRotateLeft,
    faGears, faMoneyBills, faArrowTrendDown, faRotateLeft, faPrint, faTrash, faTable, faSave, faChartLine, faUpload, faFolderTree, faCancel,
    faCommentsDollar, faQuestionCircle, faChartSimple, faHandHoldingDroplet, faEnvelope, faExchange, faSliders,
    faArrowDown, faArrowUp, faShuffle, faArrowRight, faChartBar, faEye, faMoneyCheck, faExclamationCircle, faBell, faUserGear,
    faBusinessTime, faFingerprint, faImage, faCheck, faFileInvoice, faWallet, faClipboard,
    faTriangleExclamation, faCalendarCheck, faClipboardList, faDownload, faComments, faFileArrowUp, faLink, faFileContract,
    // Added new icons
    faUserCircle, faTruck, faFileLines, faFileInvoiceDollar, faTruckFast, faHandshake, faKey, faCogs,
    faMoneyBillTrendUp, faVault, faTags, faSitemap, faBuilding, faBook, faPercent, faFileExport,
    faUsersGear, faHeadset, faTicket, faTicketSimple, faStore, faBuildingUser, faRightFromBracket, faPuzzlePiece,
    // Added icons for StoreManagements.vue
    faSignInAlt, faPlusCircle, faTag, faInfoCircle,
    // Added missing icons used in components
    faExchangeAlt, faMoneyBillWave, faUniversity,
    // Added missing icons for StockView.vue
    faTruckLoading, faFileSignature,
    // Added missing icon for SecurityManagementView.vue
    faEllipsisH,
    // Added missing icon for Invoices page
    faRedo,
    // Added missing icons for FranchiseInvoices.vue
    faClock, faFileUpload,
    // Added missing desktop icon
    faDesktop
)
